import styled, { css } from "styled-components";
import close from "../../assets/imgs/close.png";
const titles = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #000016;
  @media (max-width: 1049px) {
  }
`;
export const Container = styled.div`
  ${({ title }) => title && titles};
  padding: 40px 100px;
  animation: meals 1s ease-out forwards;

  @keyframes meals {
    from {
      transform: translateY(3rem);
    }

    to {
      transform: translateY(0);
    }
  }
`;

const Range = css`
  ::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 50%;
    width: 150px;
    height: 4px;
    background: crimson;
    transform: translateX(-50%);
  }
  ::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 50%;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: crimson;
    transform: translateX(-50%);
  }
  margin-bottom: 60px;
`;

export const Title = styled.div`
  animation: meal 1s ease-out forwards;

  @keyframes meal {
    from {
      opacity: 0;
      transform: translateY(3rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  position: relative;
  color: crimson;
  font-size: 35px;
  font-weight: 800;
  ${({ range }) => range && Range};
  margin-top: ${({ main }) => main && "167px"};
`;
const Content = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;

  margin-top: 20px;
  @media (min-width: 1024px) {
    padding: 0 66px;
  }
`;
const Card = css`
  width: 396px;
  margin: 15px;
  transition: transform 0.5s ease;
  box-shadow: 0 5px 25px rgba(1 1 1 / 15%);
  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
  @media (max-width: 1049px) {
    width: 300px;
  }
`;
const IMG = css`
  position: relative;
  width: 100%;
  height: 280px;
  border-radius: 10px;
`;
export const Wrapper = styled.div`
  ${({ content }) => content && Content};
  ${({ card }) => card && Card};
  ${({ img }) => img && IMG};
`;

export const Img = styled.img`
  top: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
  position: ${({ modal }) => !modal && "absolute"};
  border-radius: 15px;
  height: ${({ modal }) => (modal ? "500px" : "100%")};
`;
export const ModalWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* height: 80vh; */
  color: black;
  padding: 30px 100px;
  gap: 30px;

  @media (max-width: 500px) {
    overflow-y: scroll;
    height: 600px;
    padding: 40px;
  }
`;
export const Link = styled.a`
  text-decoration: none;
`;
